module.exports = __webpack_public_path__ + "media/images/slider_img_05-215f8fdbf6f97f7754011d870397c666.png";